const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  INIT_AUTOCOMPLETE_QUERY: "DEVICES_LIST/INIT_AUTOCOMPLETE_QUERY",
  SUCCESS_AUTOCOMPLETE_QUERY: "DEVICES_LIST/SUCCESS_AUTOCOMPLETE_QUERY",
  FAILURE_AUTOCOMPLETE_QUERY: "DEVICES_LIST/FAILURE_AUTOCOMPLETE_QUERY",
};

export const initialState = {
  hits: [],
  query: "",
  autocompleteFetching: false,
  autocompleteError: false,
};

export const actions = {
  initAutocompleteQuery: (data) => ({
    type: types.INIT_AUTOCOMPLETE_QUERY,
    data,
  }),
  successAutocompleteQuery: (data) => ({
    type: types.SUCCESS_AUTOCOMPLETE_QUERY,
    payload: {
      data
    },
  }),
  failureAutocompleteQuery: () => ({
    type: types.FAILURE_AUTOCOMPLETE_QUERY,
  }),
};
const Searcher = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE: {
      let { searcher } = action.payload;
      return {
        ...state,
        ...searcher,
      };
    }
    case types.INIT_AUTOCOMPLETE_QUERY: {
      return {
        ...state,
        autocompleteFetching: true,
        autocompleteError: false,
      };
    }
    case types.SUCCESS_AUTOCOMPLETE_QUERY: {
      const {
        data
      } = action.payload;
      return {
        ...state,
        hits: data.hits,
        query: data.query,
        autocompleteFetching: false,
      };
    }
    case types.FAILURE_AUTOCOMPLETE_QUERY: {
      return {
        ...state,
        ...data,
        autocompleteError: true,
      };
    }

    default:
      return state;
  }
};

export default Searcher;
